// Portal URL helper — routes customer portal traffic to dedicated 'member.*' subdomain
// when the admin is browsing from 'app.*' or 'radius.*'. Falls back to same-origin
// so localhost / dev / one-domain setups still work.
export const getPortalBaseUrl = () => {
  try {
    const { protocol, hostname, origin } = window.location;
    if (hostname.startsWith('app.') || hostname.startsWith('radius.') || hostname.startsWith('admin.')) {
      const parent = hostname.split('.').slice(1).join('.');
      return `${protocol}//member.${parent}`;
    }
    return origin;
  } catch (_e) {
    return window.location.origin;
  }
};
